import { call, put, takeLatest } from "redux-saga/effects";
import * as apis from "../../network/apis/roles";
import * as types from "./types";
import * as actions from "./actions";

function* fetchRolesSaga() {
    try {
        const response = yield call(apis.getRoles);
        yield put(actions.fetchRolesSuccess(response.data));
    } catch (error) {
        yield put(actions.fetchRolesFailure(error.message));
    }
}

export function* watchFetchRoles() {
    yield takeLatest(types.FETCH_ROLES_REQUEST, fetchRolesSaga);
}
